import { DayFormatEnum } from "./enums";

export const DEFAULT_PAX = 2;
export const DEFAULT_FOUR_BALL_PAX = 4;
export const PACKAGE_ID_PARAM = "package_id";
export const PAX_PARAM = "pax";
export const PHONE_NUMBER = "0800 043 6644";

export const DAY_VALUES = Object.freeze({
  [DayFormatEnum.SHORT]: ["S", "M", "T", "W", "T", "F", "S"],
  [DayFormatEnum.MEDIUM]: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  [DayFormatEnum.LONG]: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
});

export const DAYS_IN_WEEK = 7;
export const MAX_DAY_INDEX = 6;

export const NO_GOLF_MESSAGE =
  "There has been a problem with your tee times, please select again.";
export const NO_FLIGHT_MESSAGE =
  "There has been a problem with your flight, please select again.";
export const NO_QUOTE_MESSAGE =
  "Sorry, we have encountered a problem, please select again.";
